
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/AboutBPAY",
      function () {
        return require("private-next-pages/article/AboutBPAY.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/AboutBPAY"])
      });
    }
  